import styled from 'styled-components';

export const Container = styled.div`
  margin: auto;
  margin-top: 8px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const WhiteFooter = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  height: 1.5rem;
  margin-bottom: 1.3rem;
`;
